<div class="min-h-screen flex">

  <!-- Panel izquierdo: imagen de fondo + branding (fijo) -->
  <div class="hidden lg:flex lg:w-1/2 xl:w-3/5 sticky top-0 h-screen shrink-0 relative flex-col justify-between p-10 bg-cover bg-center bg-no-repeat"
    style="background-image: url('assets/images/bg/receipt-bg.jpg')">
    <div class="absolute inset-0 bg-slate-900/40"></div>

    <!-- Logo / branding -->
    <div class="relative z-10">
      @if (detail()?.companyLogoUrl) {
        <img [src]="detail()!.companyLogoUrl" alt="Logo empresa" class="h-16 w-auto max-w-[220px] object-contain drop-shadow-sm" />
      } @else {
        <img src="assets/images/pento-icon.png" alt="Pento" class="h-8 w-auto" />
      }
    </div>

    <!-- Tagline inferior -->
    <div class="relative z-10">
      <p class="text-white text-2xl font-semibold leading-snug max-w-sm">
        Pagos seguros,<br />simples y rápidos.
      </p>
      <p class="text-white/60 text-sm mt-2">pento.mx</p>
    </div>
  </div>

  <!-- Panel derecho: scrollable -->
  <div class="w-full lg:w-1/2 xl:w-2/5 flex flex-col bg-slate-100 overflow-y-auto">

    <!-- Logo arriba del recibo — solo mobile (en desktop va en el panel izquierdo) -->
    <div class="lg:hidden flex items-center px-6 pt-6 pb-2">
      @if (detail()?.companyLogoUrl) {
        <img [src]="detail()!.companyLogoUrl" alt="Logo empresa" class="h-9 w-auto max-w-[140px] object-contain" />
      } @else {
        <img src="assets/images/pento-icon.png" alt="Pento" class="h-7 w-auto" />
      }
    </div>

    <div class="flex-1 flex flex-col justify-center px-5 py-8 sm:px-10 max-w-lg w-full mx-auto">

      <!-- Loading -->
      @if (loading()) {
      <div class="bg-white rounded-2xl shadow-xl border border-slate-200 p-10 text-center">
        <div class="inline-block animate-spin rounded-full h-9 w-9 border-2 border-slate-200 border-t-slate-600 mb-4">
        </div>
        <p class="text-slate-400 text-sm">Cargando recibo...</p>
      </div>
      }

      <!-- Error -->
      @else if (error()) {
      <div class="bg-white rounded-2xl shadow-xl border border-slate-200 p-10 text-center">
        <div class="inline-flex items-center justify-center w-14 h-14 rounded-full bg-red-50 mb-4">
          <svg class="w-7 h-7 text-red-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"
              d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z">
            </path>
          </svg>
        </div>
        <p class="text-slate-700 font-medium">No se pudo cargar el recibo</p>
        <p class="text-slate-400 text-sm mt-1">Verifica que la URL sea correcta.</p>
      </div>
      }

      @else if (charge(); as c) {

      <!-- ── PAGADO ──────────────────────────────────── -->
      @if (isChargePaid(c)) {
      <div class="bg-white rounded-2xl shadow-xl border border-slate-200 overflow-hidden">

        <!-- Encabezado de estado -->
        <div class="bg-emerald-600 px-6 py-5 flex items-center gap-4">
          <div class="flex items-center justify-center w-11 h-11 rounded-full bg-white/20 shrink-0">
            <svg class="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M5 13l4 4L19 7"></path>
            </svg>
          </div>
          <div>
            <p class="text-white font-bold text-base leading-tight">Pago recibido</p>
            <p class="text-emerald-100 text-xs mt-0.5">Tu pago fue procesado correctamente</p>
          </div>
        </div>

        @if (detail(); as d) {
        @let sale = d.sale;
        @let currency = sale?.currency ?? 'MXN';

        <!-- Cuerpo del recibo -->
        <div class="px-6 py-5 space-y-4">

          <div class="pb-4 border-b border-dashed border-slate-200">
            <p class="text-[10px] uppercase tracking-widest text-slate-400 mb-1">Factura</p>
            <div class="flex items-center justify-between gap-2">
              <p class="font-mono font-semibold text-slate-800 text-sm">
                @if (sale?.series) { <span class="text-slate-400">{{ sale.series }} </span> }
                {{ sale?.number ?? '—' }}
              </p>
              @if (c.paymentNumber != null && c.numberOfPayments != null) {
              <p-tag severity="success">
                <span class="text-xs">Pago {{ c.paymentNumber }} de {{ c.numberOfPayments }}</span>
              </p-tag>
              }
            </div>
          </div>

          <div class="pb-4 border-b border-dashed border-slate-200">
            <p class="text-[10px] uppercase tracking-widest text-slate-400 mb-1">Cliente</p>
            <p class="text-slate-800 text-sm font-medium">{{ getCustomerName(sale) }}</p>
            @if (sale?.customer?.taxId) {
            <p class="text-slate-400 text-xs font-mono mt-0.5">{{ sale.customer.taxId }}</p>
            }
          </div>

          @if (c.paymentLink?.paidAt || c.paidAt) {
          <div class="pb-4 border-b border-dashed border-slate-200">
            <p class="text-[10px] uppercase tracking-widest text-slate-400 mb-1">Fecha de pago</p>
            <p class="text-slate-800 text-sm">{{ formatDate(c.paymentLink?.paidAt || c.paidAt) }}</p>
          </div>
          }

          @if (sale?.lines && sale.lines.length > 0) {
          <div class="pb-4 border-b border-dashed border-slate-200">
            <p class="text-[10px] uppercase tracking-widest text-slate-400 mb-2">Detalle</p>
            <div class="space-y-2">
              @for (line of sale.lines; track line.id ?? $index) {
              <div class="flex justify-between gap-2 text-sm">
                <span class="text-slate-600 flex-1 min-w-0">{{ line.quantity ?? 0 }} × {{ line.description ?? '—' }}</span>
                <span class="text-slate-800 shrink-0 font-mono">{{ formatAmount(line.totalAmount, currency) }}</span>
              </div>
              }
            </div>
          </div>
          }

          <!-- Total -->
          <div class="bg-slate-50 rounded-xl px-4 py-3 flex justify-between items-center">
            <span class="text-xs font-semibold text-slate-500 uppercase tracking-widest">Total pagado</span>
            <span class="text-2xl font-extrabold font-mono text-slate-900">{{ formatAmount(c.total, currency) }}</span>
          </div>
        </div>
        }
      </div>
      }

      <!-- ── CANCELADO / EXPIRADO ─────────────────────── -->
      @if (isChargeCancelled(c)) {
      <div class="bg-white rounded-2xl shadow-xl border border-slate-200 overflow-hidden">
        <div class="bg-slate-500 px-6 py-8 text-center">
          <div class="inline-flex items-center justify-center w-14 h-14 rounded-full bg-white/20 mb-3">
            <svg class="w-7 h-7 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z">
              </path>
            </svg>
          </div>
          <p class="text-white font-bold text-lg">Liga de pago expirada</p>
          <p class="text-slate-200 text-sm mt-1">Este recibo ya no está disponible para pago</p>
        </div>
      </div>
      }

      <!-- ── PENDIENTE ───────────────────────────────── -->
      @if (isChargePending(c)) {
      <div class="bg-white rounded-2xl shadow-xl border border-slate-200 overflow-hidden">

        <!-- Encabezado de estado: ámbar = vigente (PENDING), rojo = vencido (DUE) -->
        <div
          class="px-6 py-5 flex items-center gap-4"
          [class.bg-amber-500]="!isChargeOverdueReceipt(c)"
          [class.bg-red-600]="isChargeOverdueReceipt(c)">
          <div class="flex items-center justify-center w-11 h-11 rounded-full bg-white/20 shrink-0">
            <svg class="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z">
              </path>
            </svg>
          </div>
          <div>
            <p class="text-white font-bold text-base leading-tight">Recibo pendiente de pago</p>
            <p
              class="text-xs mt-0.5"
              [class.text-amber-100]="!isChargeOverdueReceipt(c)"
              [class.text-red-100]="isChargeOverdueReceipt(c)">
              @if (isChargeOverdueReceipt(c)) {
                La fecha de vencimiento del pago ha pasado.
              } @else {
                Este cargo aún no ha sido liquidado
              }
            </p>
          </div>
        </div>

        <!-- Importante 
        @if (isChargeOverdueReceipt(c)) {
        <div class="px-6 py-3 bg-red-50 border-b border-red-100 flex gap-3">
          <div class="shrink-0 pt-0.5">
            <svg class="w-4 h-4 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </div>
          <div class="min-w-0">
            <p class="text-[10px] font-semibold uppercase tracking-wider text-red-800 mb-1">IMPORTANTE</p>
            <p class="text-xs text-red-900/90 leading-relaxed">
              El importe mostrado corresponde al recibo original; intereses, recargos o actualizaciones
              de saldo pueden aplicarse según las condiciones acordadas.
            </p>
          </div>
        </div>
        }
        -->
        
        @if (detail(); as d) {
        @let sale = d.sale;
        @let currency = sale?.currency ?? 'MXN';

        <!-- Cuerpo del recibo -->
        <div class="px-6 py-5 space-y-4">

          <div class="pb-4 border-b border-dashed border-slate-200">
            <p class="text-[10px] uppercase tracking-widest text-slate-400 mb-1">VENTA</p>
            <div class="flex items-center justify-between gap-2">
              <p class="font-mono font-semibold text-slate-800 text-sm">
                @if (sale?.series) { <span class="text-slate-400">{{ sale.series }} </span> }
                {{ sale?.number ?? '—' }}
              </p>
              @if (c.paymentNumber != null && c.numberOfPayments != null) {
              <p-tag [severity]="isChargeOverdueReceipt(c) ? 'danger' : 'warn'">
                <span class="text-xs">Pago {{ c.paymentNumber }} de {{ c.numberOfPayments }}</span>
              </p-tag>
              }
            </div>
          </div>

          <div class="pb-4 border-b border-dashed border-slate-200">
            <p class="text-[10px] uppercase tracking-widest text-slate-400 mb-1">Cliente</p>
            <p class="text-slate-800 text-sm font-medium">{{ getCustomerName(sale) }}</p>
            @if (sale?.customer?.taxId) {
            <p class="text-slate-400 text-xs font-mono mt-0.5">{{ sale.customer.taxId }}</p>
            }
          </div>

          @if (c.dueDate) {
          <div class="pb-4 border-b border-dashed border-slate-200">
            <p class="text-[10px] uppercase tracking-widest text-slate-400 mb-1">Vencimiento</p>
            <p class="text-slate-800 text-sm">{{ formatDueDate(c.dueDate) }}</p>
          </div>
          }

          @if (sale?.lines && sale.lines.length > 0) {
          <div class="pb-4 border-b border-dashed border-slate-200">
            <p class="text-[10px] uppercase tracking-widest text-slate-400 mb-2">Detalle</p>
            <div class="space-y-2">
              @for (line of sale.lines; track line.id ?? $index) {
              <div class="flex justify-between gap-2 text-sm">
                <span class="text-slate-600 flex-1 min-w-0">{{ line.quantity ?? 0 }} × {{ line.description ?? '—' }}</span>
                <span class="text-slate-800 shrink-0 font-mono">{{ formatAmount(line.totalAmount, currency) }}</span>
              </div>
              }
            </div>
          </div>
          }

          <!-- Total -->
          <div class="bg-slate-50 rounded-xl px-4 py-3 flex justify-between items-center">
            <span class="text-xs font-semibold text-slate-500 uppercase tracking-widest">Total a pagar</span>
            <span class="text-2xl font-extrabold font-mono text-slate-900">{{ formatAmount(c.total, currency) }}</span>
          </div>
        </div>

        <!-- Footer -->
        <div class="px-6 pb-6">
          @if (getPaymentLinkUrl(c)) {
          <a [href]="getPaymentLinkUrl(c)" rel="noopener noreferrer" (click)="onPay(getPaymentLinkUrl(c), $event)"
            [class.pointer-events-none]="paymentLoading()" [class.opacity-80]="paymentLoading()"
            class="flex items-center justify-center gap-2 w-full py-3 px-4 rounded-xl bg-slate-800 hover:bg-slate-700 active:bg-slate-900 text-white text-sm font-bold transition-colors shadow-md">
            @if (paymentLoading()) {
              <svg class="animate-spin -ml-1 mr-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
              </svg>
              Cargando...
            } @else {
            <svg class="w-4 h-4 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z">
              </path>
            </svg>
            Pagar ahora
            }
          </a>
          } @else {
          <p class="text-slate-400 text-sm text-center">No hay enlace de pago disponible.</p>
          }
        </div>
        }
      </div>
      }

      }
    </div>

    <!-- Footer -->
    <div class="px-6 py-5 text-center space-y-2">
      <div class="flex items-center justify-center gap-1.5 text-slate-400">
        <svg class="w-3.5 h-3.5 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z">
          </path>
        </svg>
        <span class="text-[11px]">Pago seguro con cifrado SSL</span>
      </div>
      <p class="text-slate-300 text-[10px]">© 2025 Pento &mdash; Todos los derechos reservados</p>
    </div>
  </div>

</div>
